import { type IntlShape, defineMessage } from 'react-intl'

export const middleDotSeparatorMessage = defineMessage({
  id: '52EeVLjsAuLGrXGNC1E3',
  defaultMessage: '·',
  description: 'Middle dot separator character used between items in the shared UI component library',
})

export const pipeSeparatorMessage = defineMessage({
  id: 'fORuKXs0LVn2yL51GjhU',
  defaultMessage: '|',
  description: 'Pipe separator character used between items in the shared UI component library',
})

export const bulletSeparatorMessage = defineMessage({
  id: 'zRJKKfGtkw7FaHeh6ON8',
  defaultMessage: '•',
  description: 'Bullet separator character used between items in the shared UI component library',
})

export const arrowSeparatorMessage = defineMessage({
  id: 'sMq7ziIdq9ce5CYHbZGn',
  defaultMessage: '→',
  description: 'Right arrow separator character used between origin and destination',
})

export const dashSeparatorMessage = defineMessage({
  id: 'xlJFvjnOo3MwN_gjnxVw',
  defaultMessage: '-',
  description: 'Dash separator character used between items such as date ranges',
})

export const ampersandSeparatorMessage = defineMessage({
  id: 'VnOAw9tHP9z-Qqwfgeej',
  defaultMessage: '&',
  description: 'Ampersand separator character used between items in the shared UI component library',
})

export function formatMiddleDotSeparator(intl: IntlShape): string {
  return ` ${intl.formatMessage(middleDotSeparatorMessage)} `
}

export function formatPipeSeparator(intl: IntlShape): string {
  return ` ${intl.formatMessage(pipeSeparatorMessage)} `
}

export function formatBulletSeparator(intl: IntlShape): string {
  return ` ${intl.formatMessage(bulletSeparatorMessage)} `
}

export function formatArrowSeparator(intl: IntlShape): string {
  return ` ${intl.formatMessage(arrowSeparatorMessage)} `
}

export function formatDashSeparator(intl: IntlShape): string {
  return ` ${intl.formatMessage(dashSeparatorMessage)} `
}

export function formatAmpersandSeparator(intl: IntlShape): string {
  return ` ${intl.formatMessage(ampersandSeparatorMessage)} `
}
